"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsReport = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const patient_header_1 = require("./components/patient-header");
const react_1 = require("react");
const mobx_react_1 = require("mobx-react");
const store_1 = require("../../../../../../../../client/modules/reporting/store");
const ui_1 = require("../../../../../../../../client/components/ui");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const moment = require("moment"); // E-037.2
const button_1 = require("../../../../../../../components/material/button"); // E-037.2
let PatientsReport = class PatientsReport extends react_1.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Patient_report.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                },
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            columnDefs: [
                {
                    field: "displayName",
                    headerName: "Display Name",
                    width: 150,
                },
                {
                    field: "patientId",
                    headerName: "Patient ID",
                    width: 100,
                },
                {
                    enableRowGroup: true,
                    field: "prefix",
                    headerName: "Prefix",
                    width: 80
                },
                {
                    enableRowGroup: true,
                    field: "firstName",
                    headerName: "First Name"
                },
                {
                    enableRowGroup: true,
                    field: "middleName",
                    headerName: "Middle Name",
                    width: 150
                },
                {
                    enableRowGroup: true,
                    field: "lastName",
                    headerName: "Last Name"
                },
                {
                    enableRowGroup: true,
                    field: "suffix",
                    headerName: "Suffix",
                    width: 80
                },
                {
                    field: "birthDate",
                    headerName: "Date of Birth",
                    width: 120
                },
                {
                    field: "gender",
                    headerName: "Gender",
                },
                {
                    field: "address",
                    headerName: "Address 1",
                    width: 250
                },
                {
                    field: "address2",
                    headerName: "Address 2",
                    width: 150
                },
                {
                    field: "city",
                    headerName: "City",
                    width: 120
                },
                {
                    field: "state",
                    headerName: "State",
                    width: 100,
                },
                {
                    field: "zip",
                    headerName: "Zip",
                    width: 100,
                },
                {
                    enableRowGroup: true,
                    field: "phone",
                    headerName: "Phone"
                },
                {
                    enableRowGroup: true,
                    field: "email",
                    headerName: "Email",
                },
                {
                    field: "cardholderFirst",
                    headerName: "Cardholder First Name",
                    width: 250,
                },
                {
                    field: "cardholderLast",
                    headerName: "Cardholder Last Name",
                    width: 250,
                },
                {
                    field: "insuranceId",
                    headerName: "Insurance ID",
                    width: 150,
                },
                {
                    field: "payerGroupId",
                    headerName: "Group ID",
                    width: 150,
                },
                {
                    field: "binNum",
                    headerName: "BIN",
                    width: 150,
                },
                {
                    field: "pcn",
                    headerName: "PCN",
                    width: 150,
                },
                {
                    field: "benefitEffectiveDate",
                    headerName: "Effective Date",
                    width: 250,
                },
                {
                    field: "benefitIneffectiveDate",
                    headerName: "Ineffective Date",
                    width: 250,
                },
                {
                    field: "payerCoverageType",
                    headerName: "Coverage Type",
                    width: 250,
                },
                {
                    field: "payerIdCount",
                    headerName: "ID Count",
                    width: 250,
                },
                {
                    field: "payerIdQualifier",
                    headerName: "ID Qualifier",
                    width: 250,
                },
                {
                    field: "payerPersonCode",
                    headerName: "Person Code",
                    width: 150,
                },
                {
                    field: "payerPhone",
                    headerName: "Payer Phone",
                    width: 200,
                },
                {
                    field: "primaryInsurance",
                    headerName: "Insurance Relationship",
                    width: 150,
                },
                {
                    field: "lastErxRequestedAt",
                    headerName: "Date of last E1",
                    width: 150,
                },
                {
                    field: "nextAppointment",
                    headerName: "Next Appointment",
                    width: 150,
                },
                {
                    field: "nextRefill",
                    headerName: "Next Refill",
                    width: 300,
                },
                {
                    field: "inventoryId",
                    headerName: "Copay Card ID",
                    width: 150,
                },
            ],
            floatingFilter: true,
            multiSortKey: "ctrl",
            rowData: [],
            rowSelection: "single"
        };
    }
    async componentDidMount() {
        if (store_1.reportsStore.editModal) {
            await store_1.reportsStore.loadPatientsReport(); //E-037.2
        }
    }
    componentWillUnmount() {
        store_1.reportsStore.patientReportData = null;
    }
    render() {
        var _a;
        const storeData = store_1.reportsStore.patientReportData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        const transformedData = (_a = this.storeData.rowData) === null || _a === void 0 ? void 0 : _a.map((val) => (Object.assign(Object.assign({}, val), { pcn: '\u200B' + (val.pcn ? val.pcn : ''), binNum: '\u200B' + (val.binNum ? val.binNum : ''), birthDate: moment(val.birthDate).format("MM/DD/YYYY"), gender: val.gender == "1" ? "Male" : "Female", lastErxRequestedAt: val.lastErxRequestedAt === null ? "" : moment(val.lastErxRequestedAt).format("MM/DD/YYYY HH:mm"), benefitIneffectiveDate: val.benefitIneffectiveDate === null ? "" : moment(val.benefitIneffectiveDate).format("MM/DD/YYYY"), benefitEffectiveDate: val.benefitEffectiveDate === null ? "" : moment(val.benefitEffectiveDate).format("MM/DD/YYYY") })));
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(patient_header_1.PatientReportHeader, { title: "Patients Report", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement(button_1.MaterialButton, { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => (this.storeData.gridApi = params.api), rowData: transformedData, rowSelection: this.storeData.rowSelection, sideBar: true, suppressExcelExport: true }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(patient_header_1.PatientReportHeader, { title: "Patients Report", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(patient_header_1.PatientReportHeader, { title: "Patients Report", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
PatientsReport = __decorate([
    mobx_react_1.observer
], PatientsReport);
exports.PatientsReport = PatientsReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/patients-report/patients-report.tsx
// module id = 3989
// module chunks = 0